import React from "react";
import Slider from "Shared/Slider";
import creditRatingLabel from "src/components/CustomizePayment/PaymentFields/Sliders/CreditRatingLabel";

interface CreditRatingProps {
    creditRating: number;
    onChangeSlider: (value: number) => void;
}

const CreditRating: React.FunctionComponent<CreditRatingProps> = ({ creditRating, onChangeSlider }) => {
    return (
        <div className="CalculatorSlider">
            <div className="CalculatorSlider__container--input">
                <input value={creditRatingLabel(creditRating)} className="CalculatorSlider__input" disabled={true} />
            </div>
            <div className="CalculatorSlider__container--slider creditRating">
                <Slider
                    className="CalculatorSlider__slider"
                    min={550}
                    max={850}
                    sliderValue={creditRating}
                    step={10}
                    onChange={onChangeSlider}
                    ticks={[550, 600, 650, 700, 750, 800, 850]}
                    tickLabel=""
                    tickPrefix=""
                    controlled={true}
                />
            </div>
        </div>
    );
};

export default CreditRating;
